<template>
  <div>
    <p
      v-for="(m, index) in bb"
      :key="m"
      @click="handleClick(index)"
      :class="{ red: bc[index] }"
    >
      {{ m }}
    </p>
    <h1>我是运维管理</h1>
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        Dropdown List<el-icon class="el-icon--right"><arrow-down /></el-icon>
      </span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item command="a">Action 1</el-dropdown-item>
          <el-dropdown-item command="b">Action 2</el-dropdown-item>
          <el-dropdown-item command="c">Action 3</el-dropdown-item>
          <el-dropdown-item command="d" disabled>Action 4</el-dropdown-item>
          <el-dropdown-item command="e" divided>Action 5</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    <router-link to="/Drive">aaa</router-link>


  </div>
</template>
<script>
import { reactive, onMounted, toRefs, ref } from "vue";
import { ArrowDown } from "@element-plus/icons";
export default {
  name: "Op_manager",
  components: {
    ArrowDown,
  },
  setup() {
    const data = reactive({
      bb: ["2a", "a3", "a4", "a5"],
      bc: [false, false, false, false],
      tableData: [
        {
          date: "2016-05-03",
          name: "sss",
          state: "California",
          city: "Los Angeles",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
          tag: "Home",
        },
        {
          date: "2016-05-02",
          name: "Tom",
          state: "California",
          city: "Los Angeles",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
          tag: "Office",
        },
        {
          date: "2016-05-04",
          name: "Tom",
          state: "California",
          city: "Los Angeles",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
          tag: "Home",
        },
        {
          date: "2016-05-01",
          name: "Tom",
          state: "California",
          city: "Los Angeles",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
          tag: "Office",
        },
      ],
      a: {
        date: "2016-05-03",
        name: "sssss",
        state: "California",
        city: "Los Angeles",
        address: "No. 189, Grove St, Los Angeles",
        zip: "CA 90036",
        tag: "Home",
      },
    });
    const handleClick = (index) => {
      data.bb[index] = index;
      data.bc[index] = "true";
    };
    return { ...toRefs(data), handleClick };
  },
};
</script>
<style lang="scss" scoped>
.red {
  background-color: brown;
}
</style>